const streamModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl: '/modules/pis-tool/triggers/stream-modal/stream-modal.html',
  controller: 'StreamModalController',
};

angular
  .module('pis-tool.module')
  .component('streamModal', streamModal);
